module.exports = __webpack_public_path__ + "media/bootstrap-icons/pip-fill-3adfa809.svg";